import { render } from "./JLButton.vue?vue&type=template&id=1ac67730&scoped=true"
import script from "./JLButton.vue?vue&type=script&lang=js"
export * from "./JLButton.vue?vue&type=script&lang=js"

import "./JLButton.vue?vue&type=style&index=0&id=1ac67730&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac67730"]])

export default __exports__